// For unclear reasons the similar code from yii.js is called but doesn't affect anything.
export default function (context) {
    if (context === document) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': yii.getCsrfToken()
            }
        })
        $(document).ajaxComplete(function (event, xhr) {
            var url = xhr && xhr.getResponseHeader('X-Redirect');
            if (url) {
                window.location.assign(url);
            }
        })

        $(document).on('shown.bs.modal', function (e) {
            //fix the issue then bootstrap doesn't allow focusing elements outside modal.
            $(this).off('focusin.bs.modal')
        })
    }
}
